module.exports = __webpack_public_path__ + "img/t2-purple.82249eff.png";